module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/custom-builders/single-builder/single-builder-details/single-builder-details.component.css
// module id = ./src/app/custom-builders/single-builder/single-builder-details/single-builder-details.component.css
// module chunks = main